/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[mat-dialog-actions][_ngcontent-%COMP%]{-webkit-column-gap:8px;column-gap:8px}.loading-btn[_ngcontent-%COMP%]     .mat-button-wrapper{display:flex;align-items:center;-webkit-column-gap:8px;column-gap:8px}.loading-btn[_ngcontent-%COMP%]     .mat-progress-spinner circle, .loading-btn[_ngcontent-%COMP%]     .mat-spinner circle{stroke:#fff}.mat-flat-button.mat-primary[_ngcontent-%COMP%]{background-color:#377dff}.actions[_ngcontent-%COMP%]{display:flex}"];
export { styles as styles };
